import { Component, input, model } from '@angular/core';

import { ChoiceOption } from '../../../models';

@Component({
  selector: 'app-choice-chips',
  templateUrl: './choice-chips.component.html',
  styleUrl: './choice-chips.component.scss',
})
// A row of pill buttons standing for a choice. Single (a segmented control - a view, a zoom)
// or multiple (pick looms, pick shift patterns), with `value` a two-way model of the chosen
// values. Production plan, 2026-10-26.
export class ChoiceChipsComponent {
  public readonly options = input<ChoiceOption[]>([]);
  public readonly multiple = input(false);
  // A single choice always has one value chosen; a multiple choice may be empty.
  public readonly value = model<string[]>([]);
  public readonly ariaLabel = input<string>('');

  protected isChosen(option: ChoiceOption): boolean {
    return this.value().includes(option.value);
  }

  protected choose(option: ChoiceOption) {
    if (!this.multiple()) {
      this.value.set([option.value]);
      return;
    }

    const current = this.value();
    this.value.set(
      current.includes(option.value) ? current.filter((value) => value !== option.value) : [...current, option.value],
    );
  }

  protected chooseAll() {
    this.value.set(this.options().map((option) => option.value));
  }

  protected chooseNone() {
    this.value.set([]);
  }
}
